<template>
	<span
		class="popover-container"
		@click="onClickPopover"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
	>
		<div
			v-if="$slots['btnSlot'] != undefined"
			class="popover-container__container"
			ref="icon"
		>
			<slot name="btnSlot" />
		</div>

		<i
			v-else
			:class="[
				'icon',
				'popover-container__icon',
				iconClassName,
				popoverVisible ? 'is-active' : ''
			]"
			ref="icon"
			@click="onIconClick"
		></i>

		<Popover
			trackedRefName="icon"
			:visible="popoverVisible"
			:placement="placement"
			:zIndex="zIndex"
			:offset="[0, 22]"
			@close="onClosePopover"
			:disablePortal="disablePortal"
			:hasCloseBtn="hasCloseBtn"
			:maxWidth="maxWidth"
			:hasDivider="hasDivider"
			:state="state"
			:slim="true"
			:title="title"
			:positionStrategy="popoverStrategy"
		>
			<template v-if="!title" v-slot:popoverTitle>
				<slot name="popoverContainerTitle" />
			</template>
			<template v-slot:popoverBody>
				<slot name="popoverContainerBody" />
			</template>
			<template v-slot:popoverFooter>
				<slot name="popoverContainerFooter" />
			</template>
		</Popover>
	</span>
</template>

<script>
import Popover from '@/components/shells/popover/popover.vue';
import componentStateMixin from '@/mixins/component-state-mixin';
import componentPositionMixin from '@/mixins/component-position-mixin';

export default {
	name: 'PopoverContainer',
	mixins: [componentStateMixin, componentPositionMixin],
	components: {
		Popover
	},
	data() {
		return {
			popoverVisible: false
		};
	},
	props: {
		iconClassName: {
			type: String,
			default: 'icon-info'
		},
		disablePortal: {
			type: Boolean,
			default: true
		},
		hasCloseBtn: {
			type: Boolean,
			default: true
		},
		maxWidth: {
			type: String,
			default: 'auto'
		},
		hasDivider: {
			type: Boolean,
			default: false
		},
		triggerEventName: {
			type: String,
			default: 'click',
			validator(value) {
				return ['click', 'hover'].includes(value);
			}
		},
		title: {
			type: String,
			default: null
		},
		zIndex: {
			type: Number,
			default: 1
		},
		popoverStrategy: {
			type: String,
			default: 'absolute'
		},
		canClose: {
			type: Boolean,
			default: true
		},
		placement: {
			type: String,
			default: 'auto'
		}
	},
	methods: {
		onClickPopover() {
			if (this.triggerEventName === 'click' && this.canClose) {
				this.popoverVisible = !this.popoverVisible;
			}
		},
		onClosePopover() {
			this.popoverVisible = false;
			this.$emit('close');
		},
		onMouseEnter() {
			if (this.triggerEventName === 'hover') {
				this.popoverVisible = true;
			}
		},
		onMouseLeave() {
			if (this.triggerEventName === 'hover') {
				this.popoverVisible = false;
			}
		},
		onIconClick() {
			this.$emit('iconClick', this.popoverVisible);
		}
	}
};
</script>

<style lang="scss" scoped>
.popover-container {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&__icon {
		position: relative;
		transition: 0.05s transform ease;

		&:hover,
		&:focus,
		&.is-active {
			color: var(--brand-2);

			&:after {
				position: absolute;
				content: '';
				bottom: -$gutter-sm;
				left: 0;
				right: 0;
				border-bottom: 1px solid var(--brand-2);
			}
		}
	}
}

/* Tweak for Size in Tables */
.table {
	& .popover-container {
		&__icon {
			font-size: $table-icon-font-size;
		}
	}
}
</style>
